import styled from 'styled-components';

export const NavbarDiv = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
  align-items: flex-start;
  gap: 20px;
  padding: 16px 20px;
  position: relative;
  align-self: stretch;
  background-color: var(--white);
  z-index: 10000;
`;

export const Heading = styled.p`
  font-family: IBM Plex Sans;
  font-size: 24px;
  font-weight: 600;
  line-height: 31.2px;
  text-align: left;
  color: #1e252a;
`;

export const HeadingImage = styled.img`
  width: 32px;
  height: 32px;
  gap: 0px;
  opacity: 0px;
`;

export const NotificationHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const CloseImage = styled.img`
  cursor: pointer;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
  img {
    height: 32px;
    width: 32px;
  }
  h1 {
    font-family: var(--font-family-ibm_plex_sans);
    font-weight: 600;
    font-size: var(--font-size-xxl);
    color: var(--text);
    line-height: 31px;
  }
`;

export const Frame1409 = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  align-items: flex-start;
  flex-direction: column;
  gap: 20px;
  padding: 16px 0px;
  position: relative;
  align-self: stretch;
  background-color: var(--white);
`;
export const MaskGroup = styled.img`
  position: absolute;
  top: -15px;
  right: -15px;
  height: 35px;
  width: 35px;
`;

export const Frame15 = styled.div`
  display: flex;
  width: 380px;
  align-items: flex-start;
  gap: 10px;
  padding: 20px;
  position: relative;
  align-self: stretch;
  z-index: 100;
  height: 100%;
  flex-direction: column;
  overflow: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
  -ms-overflow-style: none;
`;
export const Frame16 = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  align-self: stretch;
  z-index: 10;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;

export const EmptyBox = styled.div`
  margin: 50px auto;
  font-family: 'IBM Plex Sans';
  font-size: 20px;
  color: rgba(48, 45, 45, 0.5);
`;

export const CloseNotification = styled.img`
  width: 35px;
  height: 35px;
  position: absolute;
  right: 15px;
  cursor: pointer;
`;

export const NotificationBody = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`;

export const PreviewButton = styled.button`
  padding: 6px 12px;
  border: 1px solid #7200E0;
  border-radius: 20px;
  background-color: white;
  color: #7200E0;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;
  
  &:hover {
    background-color: #f5e6ff;
    color: #7200E0;
  }
  
  img {
    width: 14px;
    height: 14px;
  }
`;

export const AcceptButton = styled.button`
  padding: 6px 12px;
  border: 1px solid #7200E0;
  border-radius: 20px;
  background-color: white;
  color: #7200E0;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;
  
  &:hover {
    background-color: #f5e6ff;
    color: #7200E0;
  }
  
  img {
    width: 14px;
    height: 14px;
  }
`;

export const RejectButton = styled.button`
  padding: 6px 12px;
  border: 1px solid #ef4444;
  border-radius: 20px;
  background-color: white;
  color: #ef4444;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;
  
  &:hover {
    background-color: #ffecec;
    color: #ef4444;
  }
  
  img {
    width: 14px;
    height: 14px;
  }
`;

export const SharedNotificationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 0;
  border-bottom: 1px solid rgba(30, 37, 42, 0.08);
`;

export const SharedNotificationTitle = styled.p`
  margin: 0;
  font-family: 'IBM Plex Sans';
  font-size: 14px;
  line-height: 20px;
  color: #1e252a;
`;

export const SharedNotificationSender = styled.span`
  font-weight: 600;
`;

export const SharedNotificationList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SharedNotificationItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const SharedNotificationItemTitle = styled.span`
  font-family: 'IBM Plex Sans';
  font-size: 16px;
  font-weight: 600;
  color: #1e252a;
  flex: 1;
  min-width: 160px;
`;
